import { SecurityService } from './../services/security.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanActivateChild,
  UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { AuthTypeEnum } from '../models/auth-type-enum';
import { MsalService } from '@azure/msal-angular';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private _authService: AuthService,
    private router: Router,
    private securityService: SecurityService,
    private msalService: MsalService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (environment.useFakeAuthServer === true && environment.production === false) {
      return true;
    }
    const authType = this._authService.getAuthType();
    if (authType === AuthTypeEnum.Custom) {
      if (this._authService.currentUser && this._authService.currentUser.UserName && this._authService.isAuthenticated()) {
        return true;
      } else {
        this._authService.setAuthType(AuthTypeEnum.NotAuthenticated);
        this._authService.logout();
        return false;
      }
    } else if (authType === AuthTypeEnum.OIDC) {
      // TODO authorization
      const account = this.msalService.getLogger();
      if (account) {
        return true;
      } else {
        this._authService.setAuthType(AuthTypeEnum.NotAuthenticated);
        this._authService.logout();
      }
    } else {
      this._authService.setAuthType(AuthTypeEnum.NotAuthenticated);
      this._authService.logout();
      return false;
    }
  }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

}
